<div class="spacer" *ngIf="loading">
    <usana-spinner [show]="loading" [delay]="100"></usana-spinner>
</div>
<div class="container text-center" *ngIf="!loading" [translate]="errorTag">
</div>
<br/>
